module.exports = __webpack_public_path__ + "img/sort_svg.58f30bc5.svg";